import _Vue from "vue";
import { getRequest } from "@pazion/pazion-core/src/services/auth-service";
import { stringifyUrl } from "@pazion/pazion-core/src/services/base-service";


export interface ITenant {
  changedAt: string;
  createdAt: string;
  id: number;
  isActive: number;
  isDeleted: boolean;
  name: string;
  nameTech: string;
}

export async function getCountries(filter?: any, limit?: number) {
  filter = filter || {};
  if (filter) {
    const url = stringifyUrl({
      url: "base/country",
      query: {
        filter: JSON.stringify(filter),
        limit: limit,
      },
    });
    return (await getRequest(url)).data;
  }
  return (await getRequest("catalog/country")).data;
}

export function setBeforeinstallprompt() {
  var promptEvent: any | null = null;

  // Capture event and defer
  window.addEventListener("beforeinstallprompt", function (e) {
    const installBtn: HTMLButtonElement | null =
      document.querySelector("#promptInstallPwa");
    e.preventDefault();
    promptEvent = e;
    installBtn?.classList.remove("hidden");
    listenToUserAction();
  });

  // listen to install button clic
  function listenToUserAction() {
    const installBtn: HTMLButtonElement | null =
      document.querySelector("#promptInstallPwa");
    installBtn?.addEventListener("click", presentAddToHome);
  }

  function presentAddToHome() {
    const installBtn: HTMLButtonElement | null =
      document.querySelector("#promptInstallPwa");
    promptEvent?.prompt(); // Wait for the user to respond to the prompt
    promptEvent?.userChoice.then((choice) => {
      if (choice.outcome === "accepted") {
        installBtn.classList.add("hidden");
        //console.log('User accepted');
      } else {
        //console.log('User dismissed');
      }
    });
  }
}

export async function getCurrenciesSymbol() {
  const url = stringifyUrl({
    url: "catalog/currency",
    query: {
      filter: JSON.stringify({ enabled: true }),
    },
  });
  return (await getRequest(url)).data;
}

export async function getFilesList(data: any) {
  const url = stringifyUrl({
    url: "base/files",
    query: {
      filter: JSON.stringify(data),
    },
  });
  return (await getRequest(url)).data;
}

export async function getFileContent(hash: string) {
  return (await getRequest("base/files/" + hash)).data;
}

export const getTenantList = async (): Promise<ITenant[]> => {
  return (await getRequest("base/tenants")).data;
};
